/**
 * Preview mode (soft launch): the SERVER says whether this person, or the account they are in, sees the new design before the release
 * (/me → `preview`). The switchboard reads this flag, so every "next" page is served for preview people and "legacy" for everybody else
 * without a rebuild. The browser's copy is only a DISPLAY HINT (so a reload does not flash the old pages): it counts only while a sign-in
 * token exists and only until /me has answered in this session; the server decides every request (404 outside the list), and the next
 * /me overwrites or clears the hint. A global line flipped to "next" in switchboard.ts still serves everyone at the release.
 */
const KEY = "cy_preview_user";
let memo: boolean | null = null;

const read = (): boolean => {
  try { return window.localStorage.getItem(KEY) === "1" && Boolean(window.localStorage.getItem("token")); } catch { return false; }
};

export const isPreviewUser = (): boolean => (memo === null ? (memo = read()) : memo);

export const setPreviewUser = (on: boolean): void => {
  memo = on;
  try { on ? window.localStorage.setItem(KEY, "1") : window.localStorage.removeItem(KEY); } catch { /* storage blocked: the memo rules */ }
};

export const clearPreviewUser = (): void => setPreviewUser(false);
